import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'token-create',
    path: '/tokens/create',
    component: () => LazyLoadView(import(/* webpackChunkName: "token" */ '@/views/Token/Mutate')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'token-edit',
    path: '/tokens/:id',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "token" */ '@/views/Token/Mutate')),
    beforeEnter: isAuthenticated,
  },
]
